import { EMeasureUnit } from '../store/commomTypes';

export const resolveValidMeasureUnit = (
  requestedUnit: string,
  availableUnits: string[],
  fallback: string
): string => {
  if (!availableUnits.length || availableUnits.includes(requestedUnit)) {
    return requestedUnit;
  }
  return fallback;
};

export const transformMeasureUnit = (measure: string) => {
  const measureConversionObj = {
    TO: 'T',
    ST: 'PC',
    ZBA: 'BR',
    RL: 'ROL',
    KI: 'CX'
  } as Record<string, string>;
  if (measure in measureConversionObj) {
    return measureConversionObj[measure];
  }
  return measure;
};

export const getVolumeValueToShow = (
  field?: string | number,
  measureUnit?: EMeasureUnit
): string => {
  if (!field && !measureUnit) {
    return '-';
  }
  const value =
    measureUnit === EMeasureUnit.KG || measureUnit === EMeasureUnit.T
      ? Number(field).toFixed(2).toString().replace('.', ',')
      : Number(field);

  if (isNaN(Number(field)) || Number(field) === 0) {
    return '-';
  }

  return `${value} ${measureUnit}`;
};
